import React from 'react';
import PropTypes from 'prop-types';

import { Modal, Button, CheckboxLabel, Message, Form, TooltipHelp } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { useForm } from '../../../utils/validators';
import Style from './swapSeatModalConfirm.module.css';

export default function SwapSeatModalConfirm({ show = false, onClose = () => {}, onBackToMap = () => {}, attendees = null, isSubmitting = false, onSubmit = () => {} }) {
    const { t } = useTranslation();
    const [formState, setFormState] = useForm({
        change_barcode: false,
        send_email: true
    });
    const countNewSeats = React.useMemo(() => {
        return attendees.filter(attendee => attendee.new_seat).length || 0;
    }, [attendees]);

    return (
        <Modal
            title={t('ticket.swapSeat.confirm.title')}
            subtitle={<span className={Style['subtitle']}>{t('ticket.swapSeat.confirm.subtitle', { count: attendees.filter(attendee => attendee.new_seat).length || 0 })}</span>}
            open={show}
            onClose={onClose}
            allowExternalClosing={false}
            customFooter={
                <Button.Group>
                    <Button onClick={onClose} label={t(`ticket.common.action.cancel`)} />
                    <Button primary inverted onClick={onBackToMap} label={t('ticket.common.action.back')} />
                    <Button primary onClick={() => onSubmit(formState)} label={t('ticket.common.action.save')} disabled={isSubmitting} isLoading={isSubmitting} />
                </Button.Group>
            }
        >
            <Form.Field className={Style['form-field']}>
                <CheckboxLabel
                    onChange={(e, { checked }) => setFormState('send_email', checked)}
                    label={t('ticket.swapSeat.confirm.checkboxMail')}
                    name={'send_email'}
                    checked={formState.send_email}
                />
                <TooltipHelp position="bottom" triggerOnHover title={t('ticket.swapSeat.confirm.tooltipMail')} />
            </Form.Field>
            <Form.Field className={Style['form-field']}>
                <CheckboxLabel
                    onChange={(e, { checked }) => setFormState('change_barcode', checked)}
                    label={t('ticket.swapSeat.confirm.checkboxBarcode')}
                    name={'change_barcode'}
                    checked={formState.change_barcode}
                />
                <TooltipHelp position="bottom" triggerOnHover title={t('ticket.swapSeat.confirm.tooltipBarcode')} />
            </Form.Field>
            {attendees.length - countNewSeats > 0 && (
                <Message type="warning" title={t('ticket.swapSeat.confirm.warningAttendeesWithoutNewSeats', { count: attendees.length - countNewSeats })} mini />
            )}
        </Modal>
    );
}

SwapSeatModalConfirm.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    attendees: PropTypes.array,
    onBackToMap: PropTypes.func,
    isSubmitting: PropTypes.bool
};
